export type TemplatePack = {
  name: string
  images: string[]
}

export const templatePacks: TemplatePack[] = [
  {
    name: 'Mandalas',
    images: [
      'https://cdn.magicpatterns.com/uploads/3CwVAdGnibDekmoDo4X7ik/image.png',
      'https://cdn.magicpatterns.com/uploads/jUo9ewEPyGJ95Z6u4B6WuJ/image.png',
      'https://cdn.magicpatterns.com/uploads/eXbufYnoz5vhxUrDUamh3D/image.png',
      'https://cdn.magicpatterns.com/uploads/1iUYeNXAaSrxanumyP2F6R/image.png',
      'https://cdn.magicpatterns.com/uploads/3dkso8h2WMqmtUp8w5NG26/image.png',
    ],
  },
  {
    name: 'Botánica',
    images: [
      'https://cdn.magicpatterns.com/uploads/h7h9uLrNUSzyCUz5bVVTph/image.png',
      'https://cdn.magicpatterns.com/uploads/aqnF4QVEhJ41tQ2Nt2GbLX/image.png',
      'https://cdn.magicpatterns.com/uploads/5DiV5D4QeHHKtYAECStmGJ/image.png',
      'https://cdn.magicpatterns.com/uploads/qHVT5tt3W7RwiyJr56skXm/image.png',
      'https://cdn.magicpatterns.com/uploads/kxjP7ux39irnE1rDuBsUyZ/image.png',
    ],
  },
  {
    name: 'Animales',
    images: [
      'https://cdn.magicpatterns.com/uploads/iechLejyT4mxoBB2eZm1ke/image.png',
      'https://cdn.magicpatterns.com/uploads/kb9NsBX7Mi2VXZSJ2d1onj/image.png',
      'https://cdn.magicpatterns.com/uploads/tBzvCZ35MTawdC89tS6Pv7/image.png',
      'https://cdn.magicpatterns.com/uploads/86YHnCWRUUPR5su3Hf22LB/image.png',
      'https://cdn.magicpatterns.com/uploads/3Eo8Q9AhhujWFZKbBGXcYb/image.png',
    ],
  },
  {
    name: 'Creatividad',
    images: [
      'https://cdn.magicpatterns.com/uploads/2VLbQjr3eDinbmhpzWxUwy/image.png',
      'https://cdn.magicpatterns.com/uploads/ukUYxcywkJLkjFHqY8pjEe/image.png',
      'https://cdn.magicpatterns.com/uploads/4ErBws4dWbU97C8HBwzPcY/image.png',
      'https://cdn.magicpatterns.com/uploads/mPjpUsceGkcHbSLH4QvNCj/image.png',
      'https://cdn.magicpatterns.com/uploads/8ECiMG4npbK1CGFKeehWsz/image.png',
    ],
  },
  {
    name: 'Fe Cristiana',
    images: [
      'https://cdn.magicpatterns.com/uploads/wDY9rbfZ8SvY7KTrjNqncL/image.png',
      'https://cdn.magicpatterns.com/uploads/jWamjL2exWaMvjt6JkczFn/image.png',
      'https://cdn.magicpatterns.com/uploads/pRYubY724cyiwVHhvqVn2T/image.png',
      'https://cdn.magicpatterns.com/uploads/fnktwtX2umdcxXSqhEpmoz/image.png',
      'https://cdn.magicpatterns.com/uploads/bBsYe8Zfrz8G7K2jx2iHog/image.png',
    ],
  },
  {
    name: 'Feminidad & Espiritualidad',
    images: [
      'https://cdn.magicpatterns.com/uploads/jH8JgmWk7As9ChULC2E51R/image.png',
      'https://cdn.magicpatterns.com/uploads/g19acjUm3oUMTxUJ5NmxWY/image.png',
      'https://cdn.magicpatterns.com/uploads/na7Qj1MdoxFETFDtxavC6P/image.png',
      'https://cdn.magicpatterns.com/uploads/4yCsw1sRPFQkiZCrVpcjV3/image.png',
      'https://cdn.magicpatterns.com/uploads/76VTsdxU5ubmoMP57hGgYj/image.png',
    ],
  },
  {
    name: 'Arte',
    images: [
      'https://cdn.magicpatterns.com/uploads/4rZuFXtwSDG6Cpw3eHhPRF/image.png',
      'https://cdn.magicpatterns.com/uploads/w9Kd2VbkLgVggiptuBdswq/image.png',
      'https://cdn.magicpatterns.com/uploads/8Ja9iNcAuPoQiz7a2m9ok5/image.png',
      'https://cdn.magicpatterns.com/uploads/qRaZNueezCMMB23vaFH9Xk/image.png',
    ],
  },
  {
    name: 'Más Diseños',
    images: [
      'https://cdn.magicpatterns.com/uploads/idh4qKLxS69JEkZ5WazLgh/image.png',
      'https://cdn.magicpatterns.com/uploads/db42ZPDov4WztXcfL4sqkH/image.png',
      'https://cdn.magicpatterns.com/uploads/7Wfw2FT1kWWcJxjfeLv1t5/image.png',
      'https://cdn.magicpatterns.com/uploads/s1jevARUASE6mLRP4QeCUm/image.png',
      'https://cdn.magicpatterns.com/uploads/6adWBELReLc6MbHo4VAaMB/image.png',
    ],
  },
]
